module.exports = __webpack_public_path__ + "images/twitter.9258b3dd869b5f83ff44fdd4033ffd61.svg";